var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import tracking from "@irati-tracking/admin";
import reportingService from "@irati/admin/services/reporting/reportingV2";
import reportingV2ErrorHandler from "@irati/admin/services/reporting/errors/reportingV2ErrorHandler";
import PerksActivityAndSavings from "../PerksActivityAndSavings";
import PerksGoActivityAndSavings from "../PerksGoActivityAndSavings";
import PerksByTeamActivityAndSavings from "../PerksByTeamActivityAndSavings";
import Header from "../../../components/ReportingV2/Header";
var Perks = /** @class */ (function (_super) {
    __extends(Perks, _super);
    function Perks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            perksAndPerksGoMetrics: {},
            load: hangPromise()
        };
        _this.componentDidMount = function () {
            _this.setState({
                load: _this.getPerksActivity()
            });
            tracking.viewReportingPerks();
        };
        _this.getPerksActivity = function () {
            var tenantId = authentication.userTenant().uuid;
            return reportingService
                .getPerksMetrics(tenantId)
                .then(function (_a) {
                var tenant = _a.tenant;
                _this.setState({
                    perksAndPerksGoMetrics: tenant
                });
            })
                .catch(reportingV2ErrorHandler);
        };
        return _this;
    }
    Perks.prototype.render = function () {
        var isPerksGoEnabled = authentication.apps("perks.perksGo");
        var _a = this.state, load = _a.load, perksAndPerksGoMetrics = _a.perksAndPerksGoMetrics;
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null),
            React.createElement(Loading, { load: load },
                React.createElement(PerksActivityAndSavings, { perksAndPerksGoMetrics: perksAndPerksGoMetrics }),
                isPerksGoEnabled && React.createElement(PerksGoActivityAndSavings, null),
                React.createElement(PerksByTeamActivityAndSavings, null))));
    };
    return Perks;
}(Component));
export default Perks;
